import EmptystateComparisons from "@images/emptystate-comparisons.svg";
import EmptystateEvents from "@images/emptystate-events.svg";
import EmptystateFollowedProductsRecommendations from "@images/emptystate-followedproducts-recommendations.svg";
import EmptystateFollowedProductsWatchlist from "@images/emptystate-followedproducts-watchlist.svg";
import EmptystatePortfoliosFollowed from "@images/emptystate-portfolios-followed.svg";
import EmptystatePortfoliosUser from "@images/emptystate-portfolios-user.svg";
import EmptystateSearchResults from "@images/emptystate-searchresults.svg";
import EmptystateNotifications from "@images/emptystate-notifications.svg";

export const EMPTYSTATES: Indexable<ImportedSVG> = {
  comparisons: EmptystateComparisons,
  followedProductsRecommendations: EmptystateFollowedProductsRecommendations,
  followedProductsWatchlist: EmptystateFollowedProductsWatchlist,
  portfoliosFollowed: EmptystatePortfoliosFollowed,
  portfoliosUser: EmptystatePortfoliosUser,
  searchResults: EmptystateSearchResults,
  notifications: EmptystateNotifications,
  events: EmptystateEvents,
};

export const EMPTY_PAGINATION_META: PaginationMeta = {
  current_page: 1,
  prev_page: null,
  next_page: null,
  total_pages: 0,
  total_count: 0,
};
